import apolloClient from "../apolloClient";
import { GET_WINE_CLUBS, GET_WINE_CLUB } from "./graphql";

class WineClubService {
	async all() {
		const response = await apolloClient.query({
			query: GET_WINE_CLUBS,
		});
		return response.data.wineClubs.nodes;
	}

	async get(id) {
		const response = await apolloClient.query({
			query: GET_WINE_CLUB,
			variables: {
				id,
			},
		});
		return response.data.wineClub;
	}
}

export default new WineClubService();
